import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMood = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 20,
	viewBox: "0 -960 960 960",
	width: 20,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M612-516q25 0 42.5-17.5T672-576q0-25-17.5-42.5T612-636q-25 0-42.5 17.5T552-576q0 25 17.5 42.5T612-516Zm-264 0q25 0 42.5-17.5T408-576q0-25-17.5-42.5T348-636q-25 0-42.5 17.5T288-576q0 25 17.5 42.5T348-516Zm242.5 197q50.5-31 79.5-84H290q29 53 79.5 84T480-288q60 0 110.5-31ZM331-126q-70-30-122.5-82.5T126-330.96q-30-69.96-30-149.5t30-149.04q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Q401-96 331-126Zm149-354Zm221 221q91-91 91-221t-91-221q-91-91-221-91t-221 91q-91 91-91 221t91 221q91 91 221 91t221-91Z" })
});
export default SvgMood;
